import { Routes } from '@angular/router';
import { simpleFlowGuard } from './guards/flow-guard.guard';
import { LayoutComponent } from './components/layout/layout.component';

export const routes: Routes = [
  {
    path: '',
    component: LayoutComponent,
    children: [
      {
        path: '',
        pathMatch: 'full',
        redirectTo: 'application',
      },
      /*
      {
        path: 'begin',
        loadComponent: () => import('./components/begin-step/begin-step.component').then(m => m.BeginStepComponent),
      },
      */
      {
        path: 'application',
        loadComponent: () => import('./components/application-step/application-step.component').then(m => m.ApplicationStepComponent),
      },
      {
        path: 'verify-otp',
        loadComponent: () => import('./components/verify-otp-step/verify-otp-step.component').then(m => m.VerifyOtpStepComponent),
        canActivate: [simpleFlowGuard('verify-otp', ['application'])],
      },
      {
        path: 'application-decision',
        loadComponent: () => import('./components/application-decision-step/application-decision-step.component').then(m => m.ApplicationDecisionStepComponent),
        canActivate: [simpleFlowGuard('application-decision', ['application', 'verify-otp'])],
      },
      {
        path: 'application-denial',
        loadComponent: () => import('./components/application-denial/application-denial.component').then(m => m.ApplicationDenialComponent),
        canActivate: [simpleFlowGuard('application-denial', ['application', 'verify-otp'])],
      },
      {
        path: 'accepted',
        loadComponent: () => import('./components/accepted-step/accepted-step.component').then(m => m.AcceptedStepComponent),
        canActivate: [simpleFlowGuard('accepted', ['application', 'verify-otp', 'application-decision'])],
      },
      {
        path: 'declined',
        loadComponent: () => import('./components/declined-step/declined-step.component').then(m => m.DeclinedStepComponent),
        canActivate: [simpleFlowGuard('declined', ['application', 'verify-otp', 'application-decision'])],
      },
      {
        path: 'cancel',
        loadComponent: () => import('./components/cancel-step/cancel-step.component').then(m => m.CancelStepComponent),
      },
      {
        path: 'warning',
        loadComponent: () => import('./components/warning-step/warning-step.component').then(m => m.WarningStepComponent),
      }
    ],
  },
  {
    path: '**',
    redirectTo: 'application',
    pathMatch: 'full',
  },
];
